var br = Object.defineProperty;
var wr = (t, e, r) => e in t ? br(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var Be = (t, e, r) => wr(t, typeof e != "symbol" ? e + "" : e, r);
import { a as pt, j as Sr, A as _r, u as qt, P as Er, N as nt, b as Ar, B as Se, _ as Tr, c as Nr, E as Pr, T as Or, r as xr, m as $r, d as yt, H as Kt, L as jt, S as Ir, s as J, e as Br, f as dt, D as Dr, g as Fr, h as Cr, K as kr, i as Mr, k as Lr, v as Rr, l as Ur, C as Wr, n as Vt, o as Ae, p as Hr, q as Gr } from "./FormMarkdown-DJdC9HQP.js";
import { y as fs, z as ps, F as ys, G as ds, I as ms, J as vs, M as hs, O as gs, Q as bs, R as ws, ag as Ss, V as _s, ah as Es, ai as As, U as Ts, W as Ns, X as Ps, Y as Os, Z as xs, $ as $s, a0 as Is, a1 as Bs, a2 as Ds, a3 as Fs, a4 as Cs, a5 as ks, a6 as Ms, a7 as Ls, a8 as Rs, a9 as Us, aa as Ws, w as Hs, t as Gs, ab as zs, ac as qs, ad as Ks, ae as js, af as Vs, x as Js } from "./FormMarkdown-DJdC9HQP.js";
import { jsx as l, jsxs as T, Fragment as F } from "react/jsx-runtime";
import * as z from "react";
import { useState as K, useCallback as De, useEffect as te, useRef as mt, useContext as Jt, useMemo as zr, createElement as vt } from "react";
import { q as qr, B as Kr, i as jr, L as Vr, E as Te, g as Jr, c as ht, a as Qr } from "./FilterSearch-BR-Q3sXQ.js";
import { b as Zs } from "./FilterSearch-BR-Q3sXQ.js";
class re {
  // Static method that returns an instance of the class
  static getApiEndpoint(e = "production") {
    switch (e) {
      case "development":
      case "staging":
        return "https://api.staging.eventsquare.io/1.0";
      case "production":
        return "https://api.eventsquare.io/1.0";
    }
  }
  static getAuthUrl(e = "production") {
    switch (e) {
      case "development":
      case "staging":
        return "https://accounts.staging.eventsquare.io";
      case "production":
        return "https://accounts.eventsquare.io";
    }
  }
  static getSocketAuthEndpoint(e = "production") {
    switch (e) {
      case "development":
      case "staging":
        return "https://api.staging.eventsquare.io/1.0/socket/authenticate";
      case "production":
        return "https://api.eventsquare.io/1.0/socket/authenticate";
    }
  }
  static getCookieName(e = "production") {
    switch (e) {
      case "development":
      case "staging":
        return "_esq_auth_staging";
      case "production":
        return "_esq_auth";
    }
  }
  static getCookieDomain(e = "production") {
    switch (e) {
      case "development":
        return "localhost";
      case "staging":
        return "staging.eventsquare.io";
      case "production":
        return "eventsquare.io";
    }
  }
}
class Ve {
  static get(e) {
    const r = re.getCookieName(e), n = pt.get(r);
    let a;
    if (n)
      try {
        a = Sr(n);
      } catch {
        console.error("Invalid authentication token");
      }
    return a;
  }
  static delete(e = "production") {
    const r = re.getCookieName(e), n = re.getCookieDomain(e);
    pt.remove(r, {
      domain: n,
      secure: e === "production",
      sameSite: "lax"
    });
  }
}
let gt = !0;
const Oi = ({
  children: t,
  apiClient: e,
  environment: r = "production",
  onAccountChange: n
}) => {
  const [a, o] = K(void 0), [i, c] = K(void 0), [s, y] = K(
    void 0
  ), p = Ve.get(r), d = !!p, u = re.getAuthUrl(r), v = De(async () => {
    if (e)
      try {
        const f = await e.get("/users/me");
        o(f.user);
      } catch (f) {
        e.isApiError(f) && console.log(f.response.body);
      }
  }, [e]), h = De(() => {
    const f = window.location.href, g = encodeURIComponent(f);
    window.location.replace(`${u}?redirect_url=${g}`);
  }, [u]), S = De(() => {
    Ve.delete(r), h();
  }, [r, h]), A = (f) => {
    c(f), n && n(f);
  }, O = async (f) => {
    if (!(!a || !e || f === a.language))
      try {
        const g = { ...a, language: f };
        o(g), await e.put("/users/me", {
          language: f
        });
      } catch (g) {
        e.isApiError(g) && console.log(g.response.body);
      }
  };
  if (te(() => {
    gt && d && (v(), gt = !1);
  }, [d, v]), te(() => {
    if (!a) return;
    document.documentElement.setAttribute("lang", a.language);
    const f = localStorage.getItem("account");
    if (f) {
      const g = JSON.parse(
        f
      ), P = typeof g.id > "u" ? g : g.id, $ = a.accounts.find(
        (C) => String(C.id) === String(P)
      );
      if ($) {
        c($.id);
        return;
      }
    }
    c(a.accounts[0].id);
  }, [a]), te(() => {
    if (!i) return;
    const f = a == null ? void 0 : a.accounts.find(
      (g) => g.id === i
    );
    f && (y(f), e == null || e.setTimezone(f.timezone), localStorage.setItem(
      "account",
      JSON.stringify({
        id: f.id,
        name: f.name,
        currency: f.currency,
        plan: f.plan,
        timezone: f.timezone,
        country: f.country,
        default: f.default,
        balance: f.balance
      })
    ));
  }, [i, e, a == null ? void 0 : a.accounts]), !d)
    return h(), null;
  const b = {
    account: s,
    accountId: i,
    apiClient: e,
    environment: r,
    authenticated: d,
    changeAccount: A,
    changeLanguage: O,
    fetchUser: v,
    logout: S,
    token: p,
    user: a
  };
  return /* @__PURE__ */ l(_r.Provider, { value: b, children: t });
}, Zr = "_notifications_w1cat_1", Xr = {
  notifications: Zr
}, xi = ({
  children: t,
  pusherKey: e
}) => {
  const { account: n, user: a, environment: o, apiClient: i } = qt(), c = mt(void 0), [s, y] = K(
    void 0
  ), [p, d] = K([]), u = mt(null), v = i == null ? void 0 : i.getApiKey(), h = i == null ? void 0 : i.getApiToken();
  te(() => {
    if (!n || !a || !v || !h)
      return;
    c.current || (c.current = new Er(e, {
      cluster: "eu",
      forceTLS: !0,
      authEndpoint: re.getSocketAuthEndpoint(o),
      auth: {
        headers: {
          apikey: v,
          apitoken: h
        }
      }
    }));
    const b = c.current.subscribe(
      "private-account-" + n.id
    );
    return y(b), () => {
      var f;
      b.unbind(), (f = c.current) == null || f.unsubscribe("private-account-" + (n == null ? void 0 : n.id));
    };
  }, [n, v, h, o, e, a]), te(() => {
    u.current && (u.current.style.scrollBehavior = "smooth", u.current.scrollTop = u.current.scrollHeight);
  }, [p]);
  const S = (b) => {
    b.date || (b.date = /* @__PURE__ */ new Date()), d((P) => [...P, b]);
    let f = b.sound ?? null;
    if (!b.sound)
      switch (b.type) {
        case "info":
        case "success":
          f = "notification_pop.mp3";
          break;
        case "warning":
        case "error":
          f = "notification_negative.mp3";
          break;
      }
    new Audio(`/sounds/${f}`).play().catch((P) => {
      console.error("Error playing sound:", P);
    }), setTimeout(() => {
      d(
        (P) => P.filter(($) => $.date !== b.date)
      );
    }, 5e3);
  }, A = (b) => {
    d((f) => f.filter((g) => g.date !== b.date));
  }, O = {
    accountChannel: s,
    notify: S
  };
  return /* @__PURE__ */ T(nt.Provider, { value: O, children: [
    t,
    p.length > 0 && /* @__PURE__ */ l("div", { ref: u, className: Xr.notifications, children: p.map((b, f) => {
      var g;
      return /* @__PURE__ */ l(
        Ar,
        {
          data: b,
          onRemove: A
        },
        ((g = b.date) == null ? void 0 : g.getTime()) ?? f
      );
    }) })
  ] });
}, $i = (t, e) => {
  const r = Jt(
    nt
  );
  te(() => (r.accountChannel && r.accountChannel.bind(t, e), () => {
    var n;
    (n = r.accountChannel) == null || n.unbind(t, e);
  }), [r.accountChannel, t, e]);
}, Ii = () => Jt(nt), Yr = "_back_1daoc_1", en = "_back__arrow_1daoc_4", bt = {
  back: Yr,
  back__arrow: en
}, Bi = (t) => {
  const { children: e } = t;
  return /* @__PURE__ */ l("div", { className: bt.back, children: /* @__PURE__ */ T(Se, { variant: "link", size: "small", children: [
    /* @__PURE__ */ l(qr, { className: bt.back__arrow }),
    e
  ] }) });
}, Di = (t) => /* @__PURE__ */ l(Tr, { ...t }), tn = "_editionTopbar_1f4c4_1", rn = "_editionTopbar__icon_1f4c4_4", nn = "_editionTopbar__main_1f4c4_7", on = "_editionTopbar__title_1f4c4_14", an = "_editionTopbar__eventName_1f4c4_21", sn = "_editionTopbar__editionName_1f4c4_26", cn = "_editionTopbar__storeUrl_1f4c4_33", ln = "_editionTopbar__actions_1f4c4_53", R = {
  editionTopbar: tn,
  editionTopbar__icon: rn,
  editionTopbar__main: nn,
  editionTopbar__title: on,
  editionTopbar__eventName: an,
  editionTopbar__editionName: sn,
  editionTopbar__storeUrl: cn,
  editionTopbar__actions: ln
}, Fi = (t) => {
  const { eventName: e, editionName: r, eventType: n, storeUrl: a, translations: o } = t, [i, c] = K(!1), { confetti: s } = Nr(), y = () => {
    navigator.clipboard.writeText(a);
  };
  return /* @__PURE__ */ T("div", { className: R.editionTopbar, children: [
    /* @__PURE__ */ l("div", { className: R.editionTopbar__icon, children: /* @__PURE__ */ l(Pr, { type: n }) }),
    /* @__PURE__ */ l("div", { className: R.editionTopbar__main, children: /* @__PURE__ */ T("div", { children: [
      /* @__PURE__ */ T("h5", { className: R.editionTopbar__title, children: [
        /* @__PURE__ */ l("span", { className: R.editionTopbar__eventName, children: e }),
        r && /* @__PURE__ */ l("span", { className: R.editionTopbar__editionName, children: r })
      ] }),
      /* @__PURE__ */ T("div", { className: R.editionTopbar__storeUrl, children: [
        /* @__PURE__ */ l("a", { href: a, target: "_blank", children: a.replace(/(^\w+:|^)\/\//, "") }),
        /* @__PURE__ */ l(
          Se,
          {
            variant: "link",
            size: "tiny",
            onClick: () => y(),
            children: /* @__PURE__ */ l(Kr, {})
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ T("div", { className: R.editionTopbar__actions, children: [
      /* @__PURE__ */ l("a", { href: "https://eventsquare.co", target: "_blank", children: /* @__PURE__ */ l(Se, { color: "primary", children: i ? o.store_visit : o.store_test }) }),
      /* @__PURE__ */ T(Se, { variant: "outline", children: [
        /* @__PURE__ */ l(jr, {}),
        o.share
      ] }),
      /* @__PURE__ */ l(
        Or,
        {
          checked: i,
          onChange: () => {
            i || s(), c(!i);
          }
        }
      )
    ] })
  ] });
}, un = (t) => {
  const { children: e } = t, [r, n] = K(null);
  return /* @__PURE__ */ l(
    "iframe",
    {
      srcDoc: '<!doctype html> <html lang="nl" dir="auto" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head></head><body></body></html>',
      style: {
        width: "100%",
        height: "100%",
        border: "none",
        backgroundColor: "transparent"
      },
      onLoad: (o) => {
        var s;
        const i = (s = o.target) == null ? void 0 : s.contentWindow;
        if (!i) return;
        i.document.getElementsByTagName("head")[0].remove(), i.document.getElementsByTagName("body")[0].remove();
        const c = i.document.getElementsByTagName("html")[0];
        n(c);
      },
      children: r && xr.createPortal(e, r)
    }
  );
}, Ci = ({ mjml: t }) => zr(() => {
  if (!t) return /* @__PURE__ */ l(F, {});
  const { html: e } = $r(t, {
    validationLevel: "soft",
    keepComments: !1,
    beautify: !1
  }), n = new DOMParser().parseFromString(e, "text/html");
  return /* @__PURE__ */ T(un, { children: [
    /* @__PURE__ */ l("head", { children: [...n.head.childNodes].map((a, o) => /* @__PURE__ */ l(
      Je,
      {
        index: o,
        node: a
      },
      o
    )) }),
    /* @__PURE__ */ l(Je, { node: n.body, index: 1 })
  ] });
}, [t]), fn = (t) => {
  if (!t) return;
  const e = t.split(";"), r = {};
  return e.forEach((n) => {
    if (!n) return;
    const [a, ...o] = n.split(":"), i = o.join(":").trim();
    let c = a;
    a.includes("-") && (c = a.split("-").map((s, y) => y === 0 ? s : s[0].toUpperCase() + s.slice(1)).join("")), r[c] = i;
  }), r;
}, Je = ({
  node: t,
  index: e
}) => {
  var n, a;
  if (t.nodeType === Node.COMMENT_NODE) return /* @__PURE__ */ l(F, {});
  if (t.nodeType === Node.TEXT_NODE)
    return (n = t.textContent) != null && n.trim() ? /* @__PURE__ */ l(F, { children: t.textContent }) : /* @__PURE__ */ l(F, {});
  const r = {
    //"data-selector": selector,
  };
  if ((a = t.getAttributeNames) == null || a.call(t).forEach((o) => {
    if (o) {
      let i = o;
      o === "class" && (i = "className"), o === "cellspacing" && (i = "cellSpacing"), o === "cellpadding" && (i = "cellPadding"), r[i] = t.getAttribute(o) || "";
    }
  }), t.nodeType === Node.ELEMENT_NODE) {
    const o = t.tagName.toLowerCase();
    if (o === "meta") return /* @__PURE__ */ l(F, {});
    if (o === "style")
      return vt(o, {
        ...r,
        dangerouslySetInnerHTML: {
          __html: t.textContent
        }
      });
    o === "a" && delete r.href;
    const i = vt(o, {
      ...r,
      key: e,
      style: fn(t.getAttribute("style")),
      children: t.childNodes.length === 0 ? null : [...t.childNodes].map((c, s) => /* @__PURE__ */ l(
        Je,
        {
          index: s,
          node: c
        },
        s
      ))
    });
    return /* @__PURE__ */ l(F, { children: i });
  }
  return /* @__PURE__ */ l(F, {});
}, pn = "_empty_v0gun_1", yn = "_empty__inner_v0gun_29", dn = "_popInSvg_v0gun_1", wt = {
  empty: pn,
  "empty--noMargin": "_empty--noMargin_v0gun_23",
  "empty--marginTop": "_empty--marginTop_v0gun_26",
  empty__inner: yn,
  popInSvg: dn
}, ki = (t) => {
  const { icon: e, title: r, lead: n, children: a } = t;
  return /* @__PURE__ */ l("div", { className: wt.empty, children: /* @__PURE__ */ T("div", { className: wt.empty__inner, children: [
    e || /* @__PURE__ */ l(Vr, {}),
    /* @__PURE__ */ l(yt, { variant: "h4", noMargin: !0, children: r }),
    /* @__PURE__ */ l(yt, { variant: "p", noMargin: !0, children: n }),
    a
  ] }) });
}, mn = "_eventGrid_1o46f_1", vn = {
  eventGrid: mn
}, Mi = (t) => {
  const { children: e } = t;
  return /* @__PURE__ */ l("div", { className: vn.eventGrid, children: e });
}, hn = "_bottomNavbar_3yy59_1", gn = {
  bottomNavbar: hn
}, Li = (t) => {
  const { children: e, page: r, totalPages: n } = t;
  return /* @__PURE__ */ l(
    "div",
    {
      className: gn.bottomNavbar,
      style: {
        left: `-${(r - 1) * 100}%`,
        width: `${n * 100}%`
      },
      children: e
    }
  );
}, bn = "_bottomNavbarPage_948l3_1", wn = {
  bottomNavbarPage: bn
}, Ri = (t) => {
  const { children: e } = t;
  return /* @__PURE__ */ l("div", { className: wn.bottomNavbarPage, children: e });
}, Sn = "_navBar_kgeod_1", _n = {
  navBar: Sn
}, Ui = ({ children: t }) => /* @__PURE__ */ l("nav", { className: _n.navBar, children: t }), En = "_navBarHeading_1l2hh_1", An = {
  navBarHeading: En
}, Wi = (t) => {
  const { title: e } = t;
  return /* @__PURE__ */ l("h6", { className: An.navBarHeading, children: e });
}, Tn = "_navBarList_phune_1", Nn = {
  navBarList: Tn
}, Hi = (t) => {
  const { children: e } = t;
  return /* @__PURE__ */ l("div", { className: Nn.navBarList, children: e });
}, Gi = (t) => /* @__PURE__ */ l(Kt, { ...t, type: "page" }), Pn = "_pageLoader_10u7m_1", On = {
  pageLoader: Pn
}, zi = () => /* @__PURE__ */ l("div", { className: On.pageLoader, children: /* @__PURE__ */ l(jt, { size: "large" }) }), qi = (t) => /* @__PURE__ */ l(Kt, { ...t, type: "section" }), xn = "_sidebarBottom_w5yr1_1", $n = {
  sidebarBottom: xn
}, Ki = ({ children: t }) => /* @__PURE__ */ l("div", { className: $n.sidebarBottom, children: t }), In = "_sidebarButtonLogo_13s37_1", Bn = "_logoIcon_13s37_21", Dn = "_logoBig_13s37_27", Fe = {
  sidebarButtonLogo: In,
  logoIcon: Bn,
  logoBig: Dn
}, Fn = (t) => /* @__PURE__ */ z.createElement("svg", { width: 38, height: 21, viewBox: "0 0 38 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ z.createElement("mask", { id: "mask0_196_153", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 38, height: 21 }, /* @__PURE__ */ z.createElement("path", { d: "M0 0H37.2339V20.6145H0V0Z", fill: "#303944" })), /* @__PURE__ */ z.createElement("g", { mask: "url(#mask0_196_153)" }, /* @__PURE__ */ z.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M-9.15527e-05 8.67976L37.2339 0L25.2382 20.6145L17.1367 17.0498L11.2169 20.4602L10.4383 15.4995L31.4702 3.40941L9.19227 13.6404L-9.15527e-05 8.67976Z", fill: "white" }))), ji = () => /* @__PURE__ */ T("div", { className: Fe.sidebarButtonLogo, children: [
  /* @__PURE__ */ l(Fn, { className: Fe.logoIcon }),
  /* @__PURE__ */ l(Ir, { className: Fe.logoBig })
] }), Qt = ({ children: t }) => /* @__PURE__ */ l("tbody", { className: J.tableBody, children: t });
function Cn(t, e, r) {
  const n = {
    ...t
  };
  return e.top + t.y <= r.top ? n.y = r.top - e.top : e.bottom + t.y >= r.top + r.height && (n.y = r.top + r.height - e.bottom), e.left + t.x <= r.left ? n.x = r.left - e.left : e.right + t.x >= r.left + r.width && (n.x = r.left + r.width - e.right), n;
}
const kn = (t) => {
  let {
    containerNodeRect: e,
    draggingNodeRect: r,
    transform: n
  } = t;
  return !r || !e ? n : Cn(n, r, e);
}, Mn = (t) => {
  let {
    transform: e
  } = t;
  return {
    ...e,
    x: 0
  };
}, Vi = (t) => {
  const { children: e, onDragStart: r, onDragEnd: n, onDragCancel: a } = t, o = Br(
    dt(Mr),
    dt(kr, {
      coordinateGetter: Cr
    })
  );
  return /* @__PURE__ */ l(Qt, { children: /* @__PURE__ */ l(
    Dr,
    {
      sensors: o,
      collisionDetection: Fr,
      onDragStart: r,
      onDragEnd: n,
      onDragCancel: a,
      modifiers: [Mn],
      children: e
    }
  ) });
}, Ji = (t) => {
  const { children: e, items: r } = t;
  return /* @__PURE__ */ l(Lr, { items: r, strategy: Rr, children: e });
}, Qi = (t) => {
  const { children: e, id: r, alignHandler: n = "end", ...a } = t, {
    attributes: o,
    listeners: i,
    setNodeRef: c,
    setActivatorNodeRef: s,
    transform: y,
    transition: p,
    isDragging: d
  } = Ur({ id: r, transition: { duration: 10, easing: "ease" } }), u = {
    transform: Wr.Transform.toString(y),
    transition: p,
    opacity: d ? "0" : "1"
  };
  return /* @__PURE__ */ T(Vt, { ref: c, styles: u, ...a, children: [
    n === "start" && /* @__PURE__ */ l(
      Ae,
      {
        ...o,
        ...i,
        ref: s,
        children: /* @__PURE__ */ l("div", { className: J.draghandle, children: /* @__PURE__ */ l(Te, {}) })
      }
    ),
    e,
    n === "end" && /* @__PURE__ */ l(
      Ae,
      {
        ...o,
        ...i,
        ref: s,
        children: /* @__PURE__ */ l("div", { className: J.draghandle, children: /* @__PURE__ */ l(Te, {}) })
      }
    )
  ] });
}, Zi = (t) => {
  const {
    children: e,
    isDragging: r,
    alignHandler: n = "end",
    color: a,
    colgroup: o
  } = t;
  return /* @__PURE__ */ l(Hr, { modifiers: [kn], children: r ? /* @__PURE__ */ T(Gr, { boxed: !0, clickable: !1, children: [
    o,
    /* @__PURE__ */ l(Qt, { children: /* @__PURE__ */ T(Vt, { color: a ?? void 0, children: [
      n === "start" && /* @__PURE__ */ l(Ae, { width: "2rem", children: /* @__PURE__ */ l("div", { className: J.draghandle, children: /* @__PURE__ */ l(Te, {}) }) }),
      e,
      n === "end" && /* @__PURE__ */ l(Ae, { width: "2rem", children: /* @__PURE__ */ l("div", { className: J.draghandle, children: /* @__PURE__ */ l(Te, {}) }) })
    ] }) })
  ] }) : null });
}, Xi = ({ height: t }) => /* @__PURE__ */ l("div", { style: {
  height: t
} }), Yi = (t) => {
  const { children: e } = t;
  return /* @__PURE__ */ l("strong", { className: J.tableCellTitle, children: e });
}, es = ({ children: t }) => /* @__PURE__ */ l("thead", { className: J.tableHead, children: t }), Ln = "_appLayout_1s3ow_1", Rn = "_authenticating_1s3ow_15", Un = {
  appLayout: Ln,
  authenticating: Rn
}, ts = ({ children: t }) => {
  const { user: e, accountId: r } = qt();
  return !e || !r ? null : /* @__PURE__ */ l(F, { children: /* @__PURE__ */ l("div", { className: Un.appLayout, children: t }) });
}, Wn = "_appContent_1r8u9_1", Hn = {
  appContent: Wn
}, rs = ({ children: t }) => /* @__PURE__ */ l("div", { className: Hn.appContent, children: t }), Gn = "_contentNavbar_169sy_1", zn = {
  contentNavbar: Gn
}, ns = (t) => {
  const { children: e } = t;
  return /* @__PURE__ */ l(F, { children: /* @__PURE__ */ l("nav", { className: zn.contentNavbar, children: /* @__PURE__ */ l("div", { children: e }) }) });
}, qn = "_contentMain_joyig_1", Kn = {
  contentMain: qn
}, os = (t) => {
  const { children: e } = t;
  return /* @__PURE__ */ l("main", { className: Kn.contentMain, children: e });
}, jn = "_contentTopbar_165ap_1", Vn = {
  contentTopbar: jn
}, as = ({ children: t }) => /* @__PURE__ */ l("div", { className: Vn.contentTopbar, children: t });
var Jn = Error, Qn = EvalError, Zn = RangeError, Xn = ReferenceError, Zt = SyntaxError, de = TypeError, Yn = URIError, eo = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, r = Symbol("test"), n = Object(r);
  if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
    return !1;
  var a = 42;
  e[r] = a;
  for (r in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var o = Object.getOwnPropertySymbols(e);
  if (o.length !== 1 || o[0] !== r || !Object.prototype.propertyIsEnumerable.call(e, r))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var i = Object.getOwnPropertyDescriptor(e, r);
    if (i.value !== a || i.enumerable !== !0)
      return !1;
  }
  return !0;
}, St = typeof Symbol < "u" && Symbol, to = eo, ro = function() {
  return typeof St != "function" || typeof Symbol != "function" || typeof St("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : to();
}, Ce = {
  __proto__: null,
  foo: {}
}, no = Object, oo = function() {
  return { __proto__: Ce }.foo === Ce.foo && !(Ce instanceof no);
}, ao = "Function.prototype.bind called on incompatible ", io = Object.prototype.toString, so = Math.max, co = "[object Function]", _t = function(e, r) {
  for (var n = [], a = 0; a < e.length; a += 1)
    n[a] = e[a];
  for (var o = 0; o < r.length; o += 1)
    n[o + e.length] = r[o];
  return n;
}, lo = function(e, r) {
  for (var n = [], a = r, o = 0; a < e.length; a += 1, o += 1)
    n[o] = e[a];
  return n;
}, uo = function(t, e) {
  for (var r = "", n = 0; n < t.length; n += 1)
    r += t[n], n + 1 < t.length && (r += e);
  return r;
}, fo = function(e) {
  var r = this;
  if (typeof r != "function" || io.apply(r) !== co)
    throw new TypeError(ao + r);
  for (var n = lo(arguments, 1), a, o = function() {
    if (this instanceof a) {
      var p = r.apply(
        this,
        _t(n, arguments)
      );
      return Object(p) === p ? p : this;
    }
    return r.apply(
      e,
      _t(n, arguments)
    );
  }, i = so(0, r.length - n.length), c = [], s = 0; s < i; s++)
    c[s] = "$" + s;
  if (a = Function("binder", "return function (" + uo(c, ",") + "){ return binder.apply(this,arguments); }")(o), r.prototype) {
    var y = function() {
    };
    y.prototype = r.prototype, a.prototype = new y(), y.prototype = null;
  }
  return a;
}, po = fo, ot = Function.prototype.bind || po, yo = Function.prototype.call, mo = Object.prototype.hasOwnProperty, vo = ot, ho = vo.call(yo, mo), m, go = Jn, bo = Qn, wo = Zn, So = Xn, oe = Zt, ne = de, _o = Yn, Xt = Function, ke = function(t) {
  try {
    return Xt('"use strict"; return (' + t + ").constructor;")();
  } catch {
  }
}, j = Object.getOwnPropertyDescriptor;
if (j)
  try {
    j({}, "");
  } catch {
    j = null;
  }
var Me = function() {
  throw new ne();
}, Eo = j ? function() {
  try {
    return arguments.callee, Me;
  } catch {
    try {
      return j(arguments, "callee").get;
    } catch {
      return Me;
    }
  }
}() : Me, Z = ro(), Ao = oo(), E = Object.getPrototypeOf || (Ao ? function(t) {
  return t.__proto__;
} : null), ee = {}, To = typeof Uint8Array > "u" || !E ? m : E(Uint8Array), V = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? m : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? m : ArrayBuffer,
  "%ArrayIteratorPrototype%": Z && E ? E([][Symbol.iterator]()) : m,
  "%AsyncFromSyncIteratorPrototype%": m,
  "%AsyncFunction%": ee,
  "%AsyncGenerator%": ee,
  "%AsyncGeneratorFunction%": ee,
  "%AsyncIteratorPrototype%": ee,
  "%Atomics%": typeof Atomics > "u" ? m : Atomics,
  "%BigInt%": typeof BigInt > "u" ? m : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? m : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? m : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? m : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": go,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": bo,
  "%Float32Array%": typeof Float32Array > "u" ? m : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? m : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? m : FinalizationRegistry,
  "%Function%": Xt,
  "%GeneratorFunction%": ee,
  "%Int8Array%": typeof Int8Array > "u" ? m : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? m : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? m : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": Z && E ? E(E([][Symbol.iterator]())) : m,
  "%JSON%": typeof JSON == "object" ? JSON : m,
  "%Map%": typeof Map > "u" ? m : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !Z || !E ? m : E((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? m : Promise,
  "%Proxy%": typeof Proxy > "u" ? m : Proxy,
  "%RangeError%": wo,
  "%ReferenceError%": So,
  "%Reflect%": typeof Reflect > "u" ? m : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? m : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !Z || !E ? m : E((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? m : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": Z && E ? E(""[Symbol.iterator]()) : m,
  "%Symbol%": Z ? Symbol : m,
  "%SyntaxError%": oe,
  "%ThrowTypeError%": Eo,
  "%TypedArray%": To,
  "%TypeError%": ne,
  "%Uint8Array%": typeof Uint8Array > "u" ? m : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? m : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? m : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? m : Uint32Array,
  "%URIError%": _o,
  "%WeakMap%": typeof WeakMap > "u" ? m : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? m : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? m : WeakSet
};
if (E)
  try {
    null.error;
  } catch (t) {
    var No = E(E(t));
    V["%Error.prototype%"] = No;
  }
var Po = function t(e) {
  var r;
  if (e === "%AsyncFunction%")
    r = ke("async function () {}");
  else if (e === "%GeneratorFunction%")
    r = ke("function* () {}");
  else if (e === "%AsyncGeneratorFunction%")
    r = ke("async function* () {}");
  else if (e === "%AsyncGenerator%") {
    var n = t("%AsyncGeneratorFunction%");
    n && (r = n.prototype);
  } else if (e === "%AsyncIteratorPrototype%") {
    var a = t("%AsyncGenerator%");
    a && E && (r = E(a.prototype));
  }
  return V[e] = r, r;
}, Et = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, me = ot, Ne = ho, Oo = me.call(Function.call, Array.prototype.concat), xo = me.call(Function.apply, Array.prototype.splice), At = me.call(Function.call, String.prototype.replace), Pe = me.call(Function.call, String.prototype.slice), $o = me.call(Function.call, RegExp.prototype.exec), Io = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Bo = /\\(\\)?/g, Do = function(e) {
  var r = Pe(e, 0, 1), n = Pe(e, -1);
  if (r === "%" && n !== "%")
    throw new oe("invalid intrinsic syntax, expected closing `%`");
  if (n === "%" && r !== "%")
    throw new oe("invalid intrinsic syntax, expected opening `%`");
  var a = [];
  return At(e, Io, function(o, i, c, s) {
    a[a.length] = c ? At(s, Bo, "$1") : i || o;
  }), a;
}, Fo = function(e, r) {
  var n = e, a;
  if (Ne(Et, n) && (a = Et[n], n = "%" + a[0] + "%"), Ne(V, n)) {
    var o = V[n];
    if (o === ee && (o = Po(n)), typeof o > "u" && !r)
      throw new ne("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: a,
      name: n,
      value: o
    };
  }
  throw new oe("intrinsic " + e + " does not exist!");
}, se = function(e, r) {
  if (typeof e != "string" || e.length === 0)
    throw new ne("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof r != "boolean")
    throw new ne('"allowMissing" argument must be a boolean');
  if ($o(/^%?[^%]*%?$/, e) === null)
    throw new oe("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var n = Do(e), a = n.length > 0 ? n[0] : "", o = Fo("%" + a + "%", r), i = o.name, c = o.value, s = !1, y = o.alias;
  y && (a = y[0], xo(n, Oo([0, 1], y)));
  for (var p = 1, d = !0; p < n.length; p += 1) {
    var u = n[p], v = Pe(u, 0, 1), h = Pe(u, -1);
    if ((v === '"' || v === "'" || v === "`" || h === '"' || h === "'" || h === "`") && v !== h)
      throw new oe("property names with quotes must have matching quotes");
    if ((u === "constructor" || !d) && (s = !0), a += "." + u, i = "%" + a + "%", Ne(V, i))
      c = V[i];
    else if (c != null) {
      if (!(u in c)) {
        if (!r)
          throw new ne("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if (j && p + 1 >= n.length) {
        var S = j(c, u);
        d = !!S, d && "get" in S && !("originalValue" in S.get) ? c = S.get : c = c[u];
      } else
        d = Ne(c, u), c = c[u];
      d && !s && (V[i] = c);
    }
  }
  return c;
}, Yt = { exports: {} }, Le, Tt;
function at() {
  if (Tt) return Le;
  Tt = 1;
  var t = se, e = t("%Object.defineProperty%", !0) || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return Le = e, Le;
}
var Co = se, _e = Co("%Object.getOwnPropertyDescriptor%", !0);
if (_e)
  try {
    _e([], "length");
  } catch {
    _e = null;
  }
var er = _e, Nt = at(), ko = Zt, X = de, Pt = er, Mo = function(e, r, n) {
  if (!e || typeof e != "object" && typeof e != "function")
    throw new X("`obj` must be an object or a function`");
  if (typeof r != "string" && typeof r != "symbol")
    throw new X("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new X("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new X("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new X("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new X("`loose`, if provided, must be a boolean");
  var a = arguments.length > 3 ? arguments[3] : null, o = arguments.length > 4 ? arguments[4] : null, i = arguments.length > 5 ? arguments[5] : null, c = arguments.length > 6 ? arguments[6] : !1, s = !!Pt && Pt(e, r);
  if (Nt)
    Nt(e, r, {
      configurable: i === null && s ? s.configurable : !i,
      enumerable: a === null && s ? s.enumerable : !a,
      value: n,
      writable: o === null && s ? s.writable : !o
    });
  else if (c || !a && !o && !i)
    e[r] = n;
  else
    throw new ko("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, Qe = at(), tr = function() {
  return !!Qe;
};
tr.hasArrayLengthDefineBug = function() {
  if (!Qe)
    return null;
  try {
    return Qe([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var Lo = tr, Ro = se, Ot = Mo, Uo = Lo(), xt = er, $t = de, Wo = Ro("%Math.floor%"), Ho = function(e, r) {
  if (typeof e != "function")
    throw new $t("`fn` is not a function");
  if (typeof r != "number" || r < 0 || r > 4294967295 || Wo(r) !== r)
    throw new $t("`length` must be a positive 32-bit integer");
  var n = arguments.length > 2 && !!arguments[2], a = !0, o = !0;
  if ("length" in e && xt) {
    var i = xt(e, "length");
    i && !i.configurable && (a = !1), i && !i.writable && (o = !1);
  }
  return (a || o || !n) && (Uo ? Ot(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    r,
    !0,
    !0
  ) : Ot(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    r
  )), e;
};
(function(t) {
  var e = ot, r = se, n = Ho, a = de, o = r("%Function.prototype.apply%"), i = r("%Function.prototype.call%"), c = r("%Reflect.apply%", !0) || e.call(i, o), s = at(), y = r("%Math.max%");
  t.exports = function(u) {
    if (typeof u != "function")
      throw new a("a function is required");
    var v = c(e, i, arguments);
    return n(
      v,
      1 + y(0, u.length - (arguments.length - 1)),
      !0
    );
  };
  var p = function() {
    return c(e, o, arguments);
  };
  s ? s(t.exports, "apply", { value: p }) : t.exports.apply = p;
})(Yt);
var Go = Yt.exports, rr = se, nr = Go, zo = nr(rr("String.prototype.indexOf")), qo = function(e, r) {
  var n = rr(e, !!r);
  return typeof n == "function" && zo(e, ".prototype.") > -1 ? nr(n) : n;
};
const Ko = {}, jo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ko
}, Symbol.toStringTag, { value: "Module" })), Vo = /* @__PURE__ */ Jr(jo);
var it = typeof Map == "function" && Map.prototype, Re = Object.getOwnPropertyDescriptor && it ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, Oe = it && Re && typeof Re.get == "function" ? Re.get : null, It = it && Map.prototype.forEach, st = typeof Set == "function" && Set.prototype, Ue = Object.getOwnPropertyDescriptor && st ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, xe = st && Ue && typeof Ue.get == "function" ? Ue.get : null, Bt = st && Set.prototype.forEach, Jo = typeof WeakMap == "function" && WeakMap.prototype, fe = Jo ? WeakMap.prototype.has : null, Qo = typeof WeakSet == "function" && WeakSet.prototype, pe = Qo ? WeakSet.prototype.has : null, Zo = typeof WeakRef == "function" && WeakRef.prototype, Dt = Zo ? WeakRef.prototype.deref : null, Xo = Boolean.prototype.valueOf, Yo = Object.prototype.toString, ea = Function.prototype.toString, ta = String.prototype.match, ct = String.prototype.slice, W = String.prototype.replace, ra = String.prototype.toUpperCase, Ft = String.prototype.toLowerCase, or = RegExp.prototype.test, Ct = Array.prototype.concat, D = Array.prototype.join, na = Array.prototype.slice, kt = Math.floor, Ze = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, We = Object.getOwnPropertySymbols, Xe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, ae = typeof Symbol == "function" && typeof Symbol.iterator == "object", N = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === ae || !0) ? Symbol.toStringTag : null, ar = Object.prototype.propertyIsEnumerable, Mt = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(t) {
  return t.__proto__;
} : null);
function Lt(t, e) {
  if (t === 1 / 0 || t === -1 / 0 || t !== t || t && t > -1e3 && t < 1e3 || or.call(/e/, e))
    return e;
  var r = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof t == "number") {
    var n = t < 0 ? -kt(-t) : kt(t);
    if (n !== t) {
      var a = String(n), o = ct.call(e, a.length + 1);
      return W.call(a, r, "$&_") + "." + W.call(W.call(o, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return W.call(e, r, "$&_");
}
var Ye = Vo, Rt = Ye.custom, Ut = sr(Rt) ? Rt : null, oa = function t(e, r, n, a) {
  var o = r || {};
  if (U(o, "quoteStyle") && o.quoteStyle !== "single" && o.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (U(o, "maxStringLength") && (typeof o.maxStringLength == "number" ? o.maxStringLength < 0 && o.maxStringLength !== 1 / 0 : o.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var i = U(o, "customInspect") ? o.customInspect : !0;
  if (typeof i != "boolean" && i !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (U(o, "indent") && o.indent !== null && o.indent !== "	" && !(parseInt(o.indent, 10) === o.indent && o.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (U(o, "numericSeparator") && typeof o.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var c = o.numericSeparator;
  if (typeof e > "u")
    return "undefined";
  if (e === null)
    return "null";
  if (typeof e == "boolean")
    return e ? "true" : "false";
  if (typeof e == "string")
    return lr(e, o);
  if (typeof e == "number") {
    if (e === 0)
      return 1 / 0 / e > 0 ? "0" : "-0";
    var s = String(e);
    return c ? Lt(e, s) : s;
  }
  if (typeof e == "bigint") {
    var y = String(e) + "n";
    return c ? Lt(e, y) : y;
  }
  var p = typeof o.depth > "u" ? 5 : o.depth;
  if (typeof n > "u" && (n = 0), n >= p && p > 0 && typeof e == "object")
    return et(e) ? "[Array]" : "[Object]";
  var d = _a(o, n);
  if (typeof a > "u")
    a = [];
  else if (cr(a, e) >= 0)
    return "[Circular]";
  function u(x, M, L) {
    if (M && (a = na.call(a), a.push(M)), L) {
      var le = {
        depth: o.depth
      };
      return U(o, "quoteStyle") && (le.quoteStyle = o.quoteStyle), t(x, le, n + 1, a);
    }
    return t(x, o, n + 1, a);
  }
  if (typeof e == "function" && !Wt(e)) {
    var v = ya(e), h = ge(e, u);
    return "[Function" + (v ? ": " + v : " (anonymous)") + "]" + (h.length > 0 ? " { " + D.call(h, ", ") + " }" : "");
  }
  if (sr(e)) {
    var S = ae ? W.call(String(e), /^(Symbol\(.*\))_[^)]*$/, "$1") : Xe.call(e);
    return typeof e == "object" && !ae ? ue(S) : S;
  }
  if (ba(e)) {
    for (var A = "<" + Ft.call(String(e.nodeName)), O = e.attributes || [], b = 0; b < O.length; b++)
      A += " " + O[b].name + "=" + ir(aa(O[b].value), "double", o);
    return A += ">", e.childNodes && e.childNodes.length && (A += "..."), A += "</" + Ft.call(String(e.nodeName)) + ">", A;
  }
  if (et(e)) {
    if (e.length === 0)
      return "[]";
    var f = ge(e, u);
    return d && !Sa(f) ? "[" + tt(f, d) + "]" : "[ " + D.call(f, ", ") + " ]";
  }
  if (sa(e)) {
    var g = ge(e, u);
    return !("cause" in Error.prototype) && "cause" in e && !ar.call(e, "cause") ? "{ [" + String(e) + "] " + D.call(Ct.call("[cause]: " + u(e.cause), g), ", ") + " }" : g.length === 0 ? "[" + String(e) + "]" : "{ [" + String(e) + "] " + D.call(g, ", ") + " }";
  }
  if (typeof e == "object" && i) {
    if (Ut && typeof e[Ut] == "function" && Ye)
      return Ye(e, { depth: p - n });
    if (i !== "symbol" && typeof e.inspect == "function")
      return e.inspect();
  }
  if (da(e)) {
    var P = [];
    return It && It.call(e, function(x, M) {
      P.push(u(M, e, !0) + " => " + u(x, e));
    }), Ht("Map", Oe.call(e), P, d);
  }
  if (ha(e)) {
    var $ = [];
    return Bt && Bt.call(e, function(x) {
      $.push(u(x, e));
    }), Ht("Set", xe.call(e), $, d);
  }
  if (ma(e))
    return He("WeakMap");
  if (ga(e))
    return He("WeakSet");
  if (va(e))
    return He("WeakRef");
  if (la(e))
    return ue(u(Number(e)));
  if (fa(e))
    return ue(u(Ze.call(e)));
  if (ua(e))
    return ue(Xo.call(e));
  if (ca(e))
    return ue(u(String(e)));
  if (typeof window < "u" && e === window)
    return "{ [object Window] }";
  if (typeof globalThis < "u" && e === globalThis || typeof ht < "u" && e === ht)
    return "{ [object globalThis] }";
  if (!ia(e) && !Wt(e)) {
    var C = ge(e, u), ve = Mt ? Mt(e) === Object.prototype : e instanceof Object || e.constructor === Object, G = e instanceof Object ? "" : "null prototype", k = !ve && N && Object(e) === e && N in e ? ct.call(H(e), 8, -1) : G ? "Object" : "", he = ve || typeof e.constructor != "function" ? "" : e.constructor.name ? e.constructor.name + " " : "", Q = he + (k || G ? "[" + D.call(Ct.call([], k || [], G || []), ": ") + "] " : "");
    return C.length === 0 ? Q + "{}" : d ? Q + "{" + tt(C, d) + "}" : Q + "{ " + D.call(C, ", ") + " }";
  }
  return String(e);
};
function ir(t, e, r) {
  var n = (r.quoteStyle || e) === "double" ? '"' : "'";
  return n + t + n;
}
function aa(t) {
  return W.call(String(t), /"/g, "&quot;");
}
function et(t) {
  return H(t) === "[object Array]" && (!N || !(typeof t == "object" && N in t));
}
function ia(t) {
  return H(t) === "[object Date]" && (!N || !(typeof t == "object" && N in t));
}
function Wt(t) {
  return H(t) === "[object RegExp]" && (!N || !(typeof t == "object" && N in t));
}
function sa(t) {
  return H(t) === "[object Error]" && (!N || !(typeof t == "object" && N in t));
}
function ca(t) {
  return H(t) === "[object String]" && (!N || !(typeof t == "object" && N in t));
}
function la(t) {
  return H(t) === "[object Number]" && (!N || !(typeof t == "object" && N in t));
}
function ua(t) {
  return H(t) === "[object Boolean]" && (!N || !(typeof t == "object" && N in t));
}
function sr(t) {
  if (ae)
    return t && typeof t == "object" && t instanceof Symbol;
  if (typeof t == "symbol")
    return !0;
  if (!t || typeof t != "object" || !Xe)
    return !1;
  try {
    return Xe.call(t), !0;
  } catch {
  }
  return !1;
}
function fa(t) {
  if (!t || typeof t != "object" || !Ze)
    return !1;
  try {
    return Ze.call(t), !0;
  } catch {
  }
  return !1;
}
var pa = Object.prototype.hasOwnProperty || function(t) {
  return t in this;
};
function U(t, e) {
  return pa.call(t, e);
}
function H(t) {
  return Yo.call(t);
}
function ya(t) {
  if (t.name)
    return t.name;
  var e = ta.call(ea.call(t), /^function\s*([\w$]+)/);
  return e ? e[1] : null;
}
function cr(t, e) {
  if (t.indexOf)
    return t.indexOf(e);
  for (var r = 0, n = t.length; r < n; r++)
    if (t[r] === e)
      return r;
  return -1;
}
function da(t) {
  if (!Oe || !t || typeof t != "object")
    return !1;
  try {
    Oe.call(t);
    try {
      xe.call(t);
    } catch {
      return !0;
    }
    return t instanceof Map;
  } catch {
  }
  return !1;
}
function ma(t) {
  if (!fe || !t || typeof t != "object")
    return !1;
  try {
    fe.call(t, fe);
    try {
      pe.call(t, pe);
    } catch {
      return !0;
    }
    return t instanceof WeakMap;
  } catch {
  }
  return !1;
}
function va(t) {
  if (!Dt || !t || typeof t != "object")
    return !1;
  try {
    return Dt.call(t), !0;
  } catch {
  }
  return !1;
}
function ha(t) {
  if (!xe || !t || typeof t != "object")
    return !1;
  try {
    xe.call(t);
    try {
      Oe.call(t);
    } catch {
      return !0;
    }
    return t instanceof Set;
  } catch {
  }
  return !1;
}
function ga(t) {
  if (!pe || !t || typeof t != "object")
    return !1;
  try {
    pe.call(t, pe);
    try {
      fe.call(t, fe);
    } catch {
      return !0;
    }
    return t instanceof WeakSet;
  } catch {
  }
  return !1;
}
function ba(t) {
  return !t || typeof t != "object" ? !1 : typeof HTMLElement < "u" && t instanceof HTMLElement ? !0 : typeof t.nodeName == "string" && typeof t.getAttribute == "function";
}
function lr(t, e) {
  if (t.length > e.maxStringLength) {
    var r = t.length - e.maxStringLength, n = "... " + r + " more character" + (r > 1 ? "s" : "");
    return lr(ct.call(t, 0, e.maxStringLength), e) + n;
  }
  var a = W.call(W.call(t, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, wa);
  return ir(a, "single", e);
}
function wa(t) {
  var e = t.charCodeAt(0), r = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[e];
  return r ? "\\" + r : "\\x" + (e < 16 ? "0" : "") + ra.call(e.toString(16));
}
function ue(t) {
  return "Object(" + t + ")";
}
function He(t) {
  return t + " { ? }";
}
function Ht(t, e, r, n) {
  var a = n ? tt(r, n) : D.call(r, ", ");
  return t + " (" + e + ") {" + a + "}";
}
function Sa(t) {
  for (var e = 0; e < t.length; e++)
    if (cr(t[e], `
`) >= 0)
      return !1;
  return !0;
}
function _a(t, e) {
  var r;
  if (t.indent === "	")
    r = "	";
  else if (typeof t.indent == "number" && t.indent > 0)
    r = D.call(Array(t.indent + 1), " ");
  else
    return null;
  return {
    base: r,
    prev: D.call(Array(e + 1), r)
  };
}
function tt(t, e) {
  if (t.length === 0)
    return "";
  var r = `
` + e.prev + e.base;
  return r + D.call(t, "," + r) + `
` + e.prev;
}
function ge(t, e) {
  var r = et(t), n = [];
  if (r) {
    n.length = t.length;
    for (var a = 0; a < t.length; a++)
      n[a] = U(t, a) ? e(t[a], t) : "";
  }
  var o = typeof We == "function" ? We(t) : [], i;
  if (ae) {
    i = {};
    for (var c = 0; c < o.length; c++)
      i["$" + o[c]] = o[c];
  }
  for (var s in t)
    U(t, s) && (r && String(Number(s)) === s && s < t.length || ae && i["$" + s] instanceof Symbol || (or.call(/[^\w$]/, s) ? n.push(e(s, t) + ": " + e(t[s], t)) : n.push(s + ": " + e(t[s], t))));
  if (typeof We == "function")
    for (var y = 0; y < o.length; y++)
      ar.call(t, o[y]) && n.push("[" + e(o[y]) + "]: " + e(t[o[y]], t));
  return n;
}
var ur = se, ce = qo, Ea = oa, Aa = de, be = ur("%WeakMap%", !0), we = ur("%Map%", !0), Ta = ce("WeakMap.prototype.get", !0), Na = ce("WeakMap.prototype.set", !0), Pa = ce("WeakMap.prototype.has", !0), Oa = ce("Map.prototype.get", !0), xa = ce("Map.prototype.set", !0), $a = ce("Map.prototype.has", !0), lt = function(t, e) {
  for (var r = t, n; (n = r.next) !== null; r = n)
    if (n.key === e)
      return r.next = n.next, n.next = /** @type {NonNullable<typeof list.next>} */
      t.next, t.next = n, n;
}, Ia = function(t, e) {
  var r = lt(t, e);
  return r && r.value;
}, Ba = function(t, e, r) {
  var n = lt(t, e);
  n ? n.value = r : t.next = /** @type {import('.').ListNode<typeof value>} */
  {
    // eslint-disable-line no-param-reassign, no-extra-parens
    key: e,
    next: t.next,
    value: r
  };
}, Da = function(t, e) {
  return !!lt(t, e);
}, Fa = function() {
  var e, r, n, a = {
    assert: function(o) {
      if (!a.has(o))
        throw new Aa("Side channel does not contain " + Ea(o));
    },
    get: function(o) {
      if (be && o && (typeof o == "object" || typeof o == "function")) {
        if (e)
          return Ta(e, o);
      } else if (we) {
        if (r)
          return Oa(r, o);
      } else if (n)
        return Ia(n, o);
    },
    has: function(o) {
      if (be && o && (typeof o == "object" || typeof o == "function")) {
        if (e)
          return Pa(e, o);
      } else if (we) {
        if (r)
          return $a(r, o);
      } else if (n)
        return Da(n, o);
      return !1;
    },
    set: function(o, i) {
      be && o && (typeof o == "object" || typeof o == "function") ? (e || (e = new be()), Na(e, o, i)) : we ? (r || (r = new we()), xa(r, o, i)) : (n || (n = { key: {}, next: null }), Ba(n, o, i));
    }
  };
  return a;
}, Ca = String.prototype.replace, ka = /%20/g, Ge = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, ut = {
  default: Ge.RFC3986,
  formatters: {
    RFC1738: function(t) {
      return Ca.call(t, ka, "+");
    },
    RFC3986: function(t) {
      return String(t);
    }
  },
  RFC1738: Ge.RFC1738,
  RFC3986: Ge.RFC3986
}, Ma = ut, ze = Object.prototype.hasOwnProperty, q = Array.isArray, I = function() {
  for (var t = [], e = 0; e < 256; ++e)
    t.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
  return t;
}(), La = function(e) {
  for (; e.length > 1; ) {
    var r = e.pop(), n = r.obj[r.prop];
    if (q(n)) {
      for (var a = [], o = 0; o < n.length; ++o)
        typeof n[o] < "u" && a.push(n[o]);
      r.obj[r.prop] = a;
    }
  }
}, fr = function(e, r) {
  for (var n = r && r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, a = 0; a < e.length; ++a)
    typeof e[a] < "u" && (n[a] = e[a]);
  return n;
}, Ra = function t(e, r, n) {
  if (!r)
    return e;
  if (typeof r != "object") {
    if (q(e))
      e.push(r);
    else if (e && typeof e == "object")
      (n && (n.plainObjects || n.allowPrototypes) || !ze.call(Object.prototype, r)) && (e[r] = !0);
    else
      return [e, r];
    return e;
  }
  if (!e || typeof e != "object")
    return [e].concat(r);
  var a = e;
  return q(e) && !q(r) && (a = fr(e, n)), q(e) && q(r) ? (r.forEach(function(o, i) {
    if (ze.call(e, i)) {
      var c = e[i];
      c && typeof c == "object" && o && typeof o == "object" ? e[i] = t(c, o, n) : e.push(o);
    } else
      e[i] = o;
  }), e) : Object.keys(r).reduce(function(o, i) {
    var c = r[i];
    return ze.call(o, i) ? o[i] = t(o[i], c, n) : o[i] = c, o;
  }, a);
}, Ua = function(e, r) {
  return Object.keys(r).reduce(function(n, a) {
    return n[a] = r[a], n;
  }, e);
}, Wa = function(t, e, r) {
  var n = t.replace(/\+/g, " ");
  if (r === "iso-8859-1")
    return n.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(n);
  } catch {
    return n;
  }
}, qe = 1024, Ha = function(e, r, n, a, o) {
  if (e.length === 0)
    return e;
  var i = e;
  if (typeof e == "symbol" ? i = Symbol.prototype.toString.call(e) : typeof e != "string" && (i = String(e)), n === "iso-8859-1")
    return escape(i).replace(/%u[0-9a-f]{4}/gi, function(v) {
      return "%26%23" + parseInt(v.slice(2), 16) + "%3B";
    });
  for (var c = "", s = 0; s < i.length; s += qe) {
    for (var y = i.length >= qe ? i.slice(s, s + qe) : i, p = [], d = 0; d < y.length; ++d) {
      var u = y.charCodeAt(d);
      if (u === 45 || u === 46 || u === 95 || u === 126 || u >= 48 && u <= 57 || u >= 65 && u <= 90 || u >= 97 && u <= 122 || o === Ma.RFC1738 && (u === 40 || u === 41)) {
        p[p.length] = y.charAt(d);
        continue;
      }
      if (u < 128) {
        p[p.length] = I[u];
        continue;
      }
      if (u < 2048) {
        p[p.length] = I[192 | u >> 6] + I[128 | u & 63];
        continue;
      }
      if (u < 55296 || u >= 57344) {
        p[p.length] = I[224 | u >> 12] + I[128 | u >> 6 & 63] + I[128 | u & 63];
        continue;
      }
      d += 1, u = 65536 + ((u & 1023) << 10 | y.charCodeAt(d) & 1023), p[p.length] = I[240 | u >> 18] + I[128 | u >> 12 & 63] + I[128 | u >> 6 & 63] + I[128 | u & 63];
    }
    c += p.join("");
  }
  return c;
}, Ga = function(e) {
  for (var r = [{ obj: { o: e }, prop: "o" }], n = [], a = 0; a < r.length; ++a)
    for (var o = r[a], i = o.obj[o.prop], c = Object.keys(i), s = 0; s < c.length; ++s) {
      var y = c[s], p = i[y];
      typeof p == "object" && p !== null && n.indexOf(p) === -1 && (r.push({ obj: i, prop: y }), n.push(p));
    }
  return La(r), e;
}, za = function(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}, qa = function(e) {
  return !e || typeof e != "object" ? !1 : !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
}, Ka = function(e, r) {
  return [].concat(e, r);
}, ja = function(e, r) {
  if (q(e)) {
    for (var n = [], a = 0; a < e.length; a += 1)
      n.push(r(e[a]));
    return n;
  }
  return r(e);
}, pr = {
  arrayToObject: fr,
  assign: Ua,
  combine: Ka,
  compact: Ga,
  decode: Wa,
  encode: Ha,
  isBuffer: qa,
  isRegExp: za,
  maybeMap: ja,
  merge: Ra
}, yr = Fa, Ee = pr, ye = ut, Va = Object.prototype.hasOwnProperty, dr = {
  brackets: function(e) {
    return e + "[]";
  },
  comma: "comma",
  indices: function(e, r) {
    return e + "[" + r + "]";
  },
  repeat: function(e) {
    return e;
  }
}, B = Array.isArray, Ja = Array.prototype.push, mr = function(t, e) {
  Ja.apply(t, B(e) ? e : [e]);
}, Qa = Date.prototype.toISOString, Gt = ye.default, _ = {
  addQueryPrefix: !1,
  allowDots: !1,
  allowEmptyArrays: !1,
  arrayFormat: "indices",
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encodeDotInKeys: !1,
  encoder: Ee.encode,
  encodeValuesOnly: !1,
  format: Gt,
  formatter: ye.formatters[Gt],
  // deprecated
  indices: !1,
  serializeDate: function(e) {
    return Qa.call(e);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, Za = function(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "symbol" || typeof e == "bigint";
}, Ke = {}, Xa = function t(e, r, n, a, o, i, c, s, y, p, d, u, v, h, S, A, O, b) {
  for (var f = e, g = b, P = 0, $ = !1; (g = g.get(Ke)) !== void 0 && !$; ) {
    var C = g.get(e);
    if (P += 1, typeof C < "u") {
      if (C === P)
        throw new RangeError("Cyclic object value");
      $ = !0;
    }
    typeof g.get(Ke) > "u" && (P = 0);
  }
  if (typeof p == "function" ? f = p(r, f) : f instanceof Date ? f = v(f) : n === "comma" && B(f) && (f = Ee.maybeMap(f, function(Ie) {
    return Ie instanceof Date ? v(Ie) : Ie;
  })), f === null) {
    if (i)
      return y && !A ? y(r, _.encoder, O, "key", h) : r;
    f = "";
  }
  if (Za(f) || Ee.isBuffer(f)) {
    if (y) {
      var ve = A ? r : y(r, _.encoder, O, "key", h);
      return [S(ve) + "=" + S(y(f, _.encoder, O, "value", h))];
    }
    return [S(r) + "=" + S(String(f))];
  }
  var G = [];
  if (typeof f > "u")
    return G;
  var k;
  if (n === "comma" && B(f))
    A && y && (f = Ee.maybeMap(f, y)), k = [{ value: f.length > 0 ? f.join(",") || null : void 0 }];
  else if (B(p))
    k = p;
  else {
    var he = Object.keys(f);
    k = d ? he.sort(d) : he;
  }
  var Q = s ? r.replace(/\./g, "%2E") : r, x = a && B(f) && f.length === 1 ? Q + "[]" : Q;
  if (o && B(f) && f.length === 0)
    return x + "[]";
  for (var M = 0; M < k.length; ++M) {
    var L = k[M], le = typeof L == "object" && typeof L.value < "u" ? L.value : f[L];
    if (!(c && le === null)) {
      var $e = u && s ? L.replace(/\./g, "%2E") : L, gr = B(f) ? typeof n == "function" ? n(x, $e) : x : x + (u ? "." + $e : "[" + $e + "]");
      b.set(e, P);
      var ft = yr();
      ft.set(Ke, b), mr(G, t(
        le,
        gr,
        n,
        a,
        o,
        i,
        c,
        s,
        n === "comma" && A && B(f) ? null : y,
        p,
        d,
        u,
        v,
        h,
        S,
        A,
        O,
        ft
      ));
    }
  }
  return G;
}, Ya = function(e) {
  if (!e)
    return _;
  if (typeof e.allowEmptyArrays < "u" && typeof e.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof e.encodeDotInKeys < "u" && typeof e.encodeDotInKeys != "boolean")
    throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
  if (e.encoder !== null && typeof e.encoder < "u" && typeof e.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var r = e.charset || _.charset;
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var n = ye.default;
  if (typeof e.format < "u") {
    if (!Va.call(ye.formatters, e.format))
      throw new TypeError("Unknown format option provided.");
    n = e.format;
  }
  var a = ye.formatters[n], o = _.filter;
  (typeof e.filter == "function" || B(e.filter)) && (o = e.filter);
  var i;
  if (e.arrayFormat in dr ? i = e.arrayFormat : "indices" in e ? i = e.indices ? "indices" : "repeat" : i = _.arrayFormat, "commaRoundTrip" in e && typeof e.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var c = typeof e.allowDots > "u" ? e.encodeDotInKeys === !0 ? !0 : _.allowDots : !!e.allowDots;
  return {
    addQueryPrefix: typeof e.addQueryPrefix == "boolean" ? e.addQueryPrefix : _.addQueryPrefix,
    allowDots: c,
    allowEmptyArrays: typeof e.allowEmptyArrays == "boolean" ? !!e.allowEmptyArrays : _.allowEmptyArrays,
    arrayFormat: i,
    charset: r,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : _.charsetSentinel,
    commaRoundTrip: e.commaRoundTrip,
    delimiter: typeof e.delimiter > "u" ? _.delimiter : e.delimiter,
    encode: typeof e.encode == "boolean" ? e.encode : _.encode,
    encodeDotInKeys: typeof e.encodeDotInKeys == "boolean" ? e.encodeDotInKeys : _.encodeDotInKeys,
    encoder: typeof e.encoder == "function" ? e.encoder : _.encoder,
    encodeValuesOnly: typeof e.encodeValuesOnly == "boolean" ? e.encodeValuesOnly : _.encodeValuesOnly,
    filter: o,
    format: n,
    formatter: a,
    serializeDate: typeof e.serializeDate == "function" ? e.serializeDate : _.serializeDate,
    skipNulls: typeof e.skipNulls == "boolean" ? e.skipNulls : _.skipNulls,
    sort: typeof e.sort == "function" ? e.sort : null,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : _.strictNullHandling
  };
}, ei = function(t, e) {
  var r = t, n = Ya(e), a, o;
  typeof n.filter == "function" ? (o = n.filter, r = o("", r)) : B(n.filter) && (o = n.filter, a = o);
  var i = [];
  if (typeof r != "object" || r === null)
    return "";
  var c = dr[n.arrayFormat], s = c === "comma" && n.commaRoundTrip;
  a || (a = Object.keys(r)), n.sort && a.sort(n.sort);
  for (var y = yr(), p = 0; p < a.length; ++p) {
    var d = a[p];
    n.skipNulls && r[d] === null || mr(i, Xa(
      r[d],
      d,
      c,
      s,
      n.allowEmptyArrays,
      n.strictNullHandling,
      n.skipNulls,
      n.encodeDotInKeys,
      n.encode ? n.encoder : null,
      n.filter,
      n.sort,
      n.allowDots,
      n.serializeDate,
      n.format,
      n.formatter,
      n.encodeValuesOnly,
      n.charset,
      y
    ));
  }
  var u = i.join(n.delimiter), v = n.addQueryPrefix === !0 ? "?" : "";
  return n.charsetSentinel && (n.charset === "iso-8859-1" ? v += "utf8=%26%2310003%3B&" : v += "utf8=%E2%9C%93&"), u.length > 0 ? v + u : "";
}, ie = pr, rt = Object.prototype.hasOwnProperty, ti = Array.isArray, w = {
  allowDots: !1,
  allowEmptyArrays: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decodeDotInKeys: !1,
  decoder: ie.decode,
  delimiter: "&",
  depth: 5,
  duplicates: "combine",
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictDepth: !1,
  strictNullHandling: !1
}, ri = function(t) {
  return t.replace(/&#(\d+);/g, function(e, r) {
    return String.fromCharCode(parseInt(r, 10));
  });
}, vr = function(t, e) {
  return t && typeof t == "string" && e.comma && t.indexOf(",") > -1 ? t.split(",") : t;
}, ni = "utf8=%26%2310003%3B", oi = "utf8=%E2%9C%93", ai = function(e, r) {
  var n = { __proto__: null }, a = r.ignoreQueryPrefix ? e.replace(/^\?/, "") : e;
  a = a.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  var o = r.parameterLimit === 1 / 0 ? void 0 : r.parameterLimit, i = a.split(r.delimiter, o), c = -1, s, y = r.charset;
  if (r.charsetSentinel)
    for (s = 0; s < i.length; ++s)
      i[s].indexOf("utf8=") === 0 && (i[s] === oi ? y = "utf-8" : i[s] === ni && (y = "iso-8859-1"), c = s, s = i.length);
  for (s = 0; s < i.length; ++s)
    if (s !== c) {
      var p = i[s], d = p.indexOf("]="), u = d === -1 ? p.indexOf("=") : d + 1, v, h;
      u === -1 ? (v = r.decoder(p, w.decoder, y, "key"), h = r.strictNullHandling ? null : "") : (v = r.decoder(p.slice(0, u), w.decoder, y, "key"), h = ie.maybeMap(
        vr(p.slice(u + 1), r),
        function(A) {
          return r.decoder(A, w.decoder, y, "value");
        }
      )), h && r.interpretNumericEntities && y === "iso-8859-1" && (h = ri(h)), p.indexOf("[]=") > -1 && (h = ti(h) ? [h] : h);
      var S = rt.call(n, v);
      S && r.duplicates === "combine" ? n[v] = ie.combine(n[v], h) : (!S || r.duplicates === "last") && (n[v] = h);
    }
  return n;
}, ii = function(t, e, r, n) {
  for (var a = n ? e : vr(e, r), o = t.length - 1; o >= 0; --o) {
    var i, c = t[o];
    if (c === "[]" && r.parseArrays)
      i = r.allowEmptyArrays && (a === "" || r.strictNullHandling && a === null) ? [] : [].concat(a);
    else {
      i = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var s = c.charAt(0) === "[" && c.charAt(c.length - 1) === "]" ? c.slice(1, -1) : c, y = r.decodeDotInKeys ? s.replace(/%2E/g, ".") : s, p = parseInt(y, 10);
      !r.parseArrays && y === "" ? i = { 0: a } : !isNaN(p) && c !== y && String(p) === y && p >= 0 && r.parseArrays && p <= r.arrayLimit ? (i = [], i[p] = a) : y !== "__proto__" && (i[y] = a);
    }
    a = i;
  }
  return a;
}, si = function(e, r, n, a) {
  if (e) {
    var o = n.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e, i = /(\[[^[\]]*])/, c = /(\[[^[\]]*])/g, s = n.depth > 0 && i.exec(o), y = s ? o.slice(0, s.index) : o, p = [];
    if (y) {
      if (!n.plainObjects && rt.call(Object.prototype, y) && !n.allowPrototypes)
        return;
      p.push(y);
    }
    for (var d = 0; n.depth > 0 && (s = c.exec(o)) !== null && d < n.depth; ) {
      if (d += 1, !n.plainObjects && rt.call(Object.prototype, s[1].slice(1, -1)) && !n.allowPrototypes)
        return;
      p.push(s[1]);
    }
    if (s) {
      if (n.strictDepth === !0)
        throw new RangeError("Input depth exceeded depth option of " + n.depth + " and strictDepth is true");
      p.push("[" + o.slice(s.index) + "]");
    }
    return ii(p, r, n, a);
  }
}, ci = function(e) {
  if (!e)
    return w;
  if (typeof e.allowEmptyArrays < "u" && typeof e.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof e.decodeDotInKeys < "u" && typeof e.decodeDotInKeys != "boolean")
    throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
  if (e.decoder !== null && typeof e.decoder < "u" && typeof e.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var r = typeof e.charset > "u" ? w.charset : e.charset, n = typeof e.duplicates > "u" ? w.duplicates : e.duplicates;
  if (n !== "combine" && n !== "first" && n !== "last")
    throw new TypeError("The duplicates option must be either combine, first, or last");
  var a = typeof e.allowDots > "u" ? e.decodeDotInKeys === !0 ? !0 : w.allowDots : !!e.allowDots;
  return {
    allowDots: a,
    allowEmptyArrays: typeof e.allowEmptyArrays == "boolean" ? !!e.allowEmptyArrays : w.allowEmptyArrays,
    allowPrototypes: typeof e.allowPrototypes == "boolean" ? e.allowPrototypes : w.allowPrototypes,
    allowSparse: typeof e.allowSparse == "boolean" ? e.allowSparse : w.allowSparse,
    arrayLimit: typeof e.arrayLimit == "number" ? e.arrayLimit : w.arrayLimit,
    charset: r,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : w.charsetSentinel,
    comma: typeof e.comma == "boolean" ? e.comma : w.comma,
    decodeDotInKeys: typeof e.decodeDotInKeys == "boolean" ? e.decodeDotInKeys : w.decodeDotInKeys,
    decoder: typeof e.decoder == "function" ? e.decoder : w.decoder,
    delimiter: typeof e.delimiter == "string" || ie.isRegExp(e.delimiter) ? e.delimiter : w.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof e.depth == "number" || e.depth === !1 ? +e.depth : w.depth,
    duplicates: n,
    ignoreQueryPrefix: e.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof e.interpretNumericEntities == "boolean" ? e.interpretNumericEntities : w.interpretNumericEntities,
    parameterLimit: typeof e.parameterLimit == "number" ? e.parameterLimit : w.parameterLimit,
    parseArrays: e.parseArrays !== !1,
    plainObjects: typeof e.plainObjects == "boolean" ? e.plainObjects : w.plainObjects,
    strictDepth: typeof e.strictDepth == "boolean" ? !!e.strictDepth : w.strictDepth,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : w.strictNullHandling
  };
}, li = function(t, e) {
  var r = ci(e);
  if (t === "" || t === null || typeof t > "u")
    return r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var n = typeof t == "string" ? ai(t, r) : t, a = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, o = Object.keys(n), i = 0; i < o.length; ++i) {
    var c = o[i], s = si(c, n[c], r, typeof t == "string");
    a = ie.merge(a, s, r);
  }
  return r.allowSparse === !0 ? a : ie.compact(a);
}, ui = ei, fi = li, pi = ut, yi = {
  formats: pi,
  parse: fi,
  stringify: ui
};
const di = /* @__PURE__ */ Qr(yi);
class hr {
  constructor(e) {
    // Default config
    Be(this, "config", {
      environment: "production",
      apiEndpoint: "https://api.eventsquare.io/1.0",
      apiKey: "",
      apiToken: void 0,
      timezone: "Europe/Brussels"
    });
    e.environment && (this.config.apiEndpoint = re.getApiEndpoint(
      e.environment
    )), this.config = { ...this.config, ...e };
    const r = Ve.get(this.config.environment ?? "production");
    r && (this.config.apiToken = r.token);
  }
  // Static method that returns an instance of the class
  static create(e) {
    return new hr(e);
  }
  getApiKey() {
    return this.config.apiKey;
  }
  getApiToken() {
    return this.config.apiToken;
  }
  constructHeaders(e, r = !1) {
    let n = {};
    return r || (n["Content-Type"] = "application/json"), this.setTimezone(), this.config.timezone && (n["X-Timezone"] = this.config.timezone, n.timezone = this.config.timezone), this.config.apiKey && (n.apikey = this.config.apiKey), this.config.apiToken && (n.apitoken = this.config.apiToken), e && (n = { ...n, ...e }), n;
  }
  setTimezone(e = void 0) {
    if (e) {
      this.config.timezone = e;
      return;
    }
    const r = localStorage.getItem("account");
    if (!r) {
      this.config.timezone = "Europe/Brussels";
      return;
    }
    const n = JSON.parse(r);
    this.config.timezone = typeof n.timezone > "u" ? "Europe/Brussels" : n.timezone;
  }
  // Static method to check if error is of type EventSquareApiError
  isApiError(e) {
    return e instanceof Y;
  }
  async get(e, r, n) {
    const a = r && Object.keys(r).length > 0 ? "?" + di.stringify(r, { encode: !1, skipNulls: !0 }) : "", o = await fetch(
      `${this.config.apiEndpoint}${e ?? ""}${a}`,
      {
        method: "GET",
        headers: this.constructHeaders(n)
      }
    );
    if (o.ok) {
      const i = o.headers.get("Content-Type");
      return i && i.includes("application/json") ? o.json() : {};
    } else
      throw new Y({
        status: o.status,
        statusText: o.statusText,
        headers: o.headers,
        body: await o.json()
      });
  }
  async post(e, r, n) {
    const a = await fetch(`${this.config.apiEndpoint}${e}`, {
      method: "POST",
      headers: this.constructHeaders(n),
      body: JSON.stringify(r)
    });
    if (a.ok) {
      const o = a.headers.get("Content-Type");
      return o && o.includes("application/json") ? a.json() : {};
    } else
      throw new Y({
        status: a.status,
        statusText: a.statusText,
        headers: a.headers,
        body: await a.json()
      });
  }
  async put(e, r, n) {
    const a = await fetch(`${this.config.apiEndpoint}${e}`, {
      method: "PUT",
      headers: this.constructHeaders(n),
      body: JSON.stringify(r)
    });
    if (a.ok) {
      const o = a.headers.get("Content-Type");
      return o && o.includes("application/json") ? a.json() : {};
    } else
      throw new Y({
        status: a.status,
        statusText: a.statusText,
        headers: a.headers,
        body: await a.json()
      });
  }
  async delete(e, r, n) {
    const a = await fetch(`${this.config.apiEndpoint}${e}`, {
      method: "DELETE",
      headers: this.constructHeaders(n),
      body: r ? JSON.stringify(r) : void 0
    });
    if (a.ok) {
      const o = a.headers.get("Content-Type");
      return o && o.includes("application/json") ? a.json() : {};
    } else
      throw new Y({
        status: a.status,
        statusText: a.statusText,
        headers: a.headers,
        body: await a.json()
      });
  }
  async uploadMedia(e, r, n, a) {
    const o = new FormData();
    o.append("file", n), o.append("type", r);
    const i = await fetch(
      `${this.config.apiEndpoint}/accounts/${e}/media`,
      {
        method: "POST",
        headers: this.constructHeaders(a, !0),
        body: o
      }
    );
    if (i.ok) {
      const c = i.headers.get("Content-Type");
      return c && c.includes("application/json") ? i.json() : {};
    } else
      throw new Y({
        status: i.status,
        statusText: i.statusText,
        headers: i.headers,
        body: await i.json()
      });
  }
}
class Y extends Error {
  constructor(r) {
    super("EventSquare API Error");
    Be(this, "response");
    this.response = r;
  }
}
const mi = "_form_w4pp0_1", vi = "_loader_w4pp0_5", zt = {
  form: mi,
  loader: vi
}, is = (t) => {
  const { children: e, onSubmit: r, loading: n, maxWidth: a = "auto" } = t;
  return /* @__PURE__ */ T(
    "form",
    {
      className: zt.form,
      style: { maxWidth: a },
      onSubmit: r,
      children: [
        e,
        n && /* @__PURE__ */ l("div", { className: zt.loader, children: /* @__PURE__ */ l(jt, { size: "large" }) })
      ]
    }
  );
}, hi = "_select_19c2m_1", gi = "_wrapper_19c2m_43", bi = "_arrow_19c2m_48", je = {
  select: hi,
  wrapper: gi,
  arrow: bi
}, wi = (t) => /* @__PURE__ */ z.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", ...t }, /* @__PURE__ */ z.createElement("path", { d: "M12 15.0006L7.75732 10.758L9.17154 9.34375L12 12.1722L14.8284 9.34375L16.2426 10.758L12 15.0006Z" })), ss = (t) => {
  const {
    value: e,
    onChange: r,
    name: n,
    placeholder: a,
    options: o,
    autoComplete: i,
    id: c,
    disabled: s
  } = t;
  return /* @__PURE__ */ T("div", { className: je.wrapper, children: [
    /* @__PURE__ */ T(
      "select",
      {
        className: je.select,
        name: n,
        value: e,
        onChange: r,
        autoComplete: i,
        id: c,
        disabled: s,
        children: [
          a && /* @__PURE__ */ l("option", { value: "", disabled: !0, children: a }),
          o.map((y) => /* @__PURE__ */ l("option", { value: y.value, children: y.label }, y.value))
        ]
      }
    ),
    /* @__PURE__ */ l(wi, { className: je.arrow })
  ] });
}, Si = "_formTextArea_19hw2_1", _i = {
  formTextArea: Si
}, cs = (t) => {
  const { id: e, name: r, onChange: n, placeholder: a, rows: o, value: i, disabled: c } = t;
  return /* @__PURE__ */ l(
    "textarea",
    {
      className: _i.formTextArea,
      id: e,
      name: r,
      onChange: n,
      placeholder: a,
      rows: o,
      value: i,
      disabled: c
    }
  );
};
export {
  fs as Accordion,
  ps as AccordionItem,
  hr as ApiClient,
  Oi as AuthProvider,
  Ve as AuthToken,
  Bi as BackButton,
  Zs as Badge,
  Se as Button,
  ys as ButtonGroup,
  ds as Calendar,
  ms as Checkbox,
  vs as Container,
  Di as Count,
  hs as Dropdown,
  gs as DropdownItem,
  Fi as EditionTopbar,
  Ci as EmailPreview,
  ki as Empty,
  re as Environment,
  bs as EventCard,
  Mi as EventGrid,
  Pr as EventIcon,
  ws as Flexbox,
  is as Form,
  Ss as FormCheckbox,
  _s as FormGrid,
  Es as FormInput,
  As as FormMarkdown,
  ss as FormSelect,
  cs as FormTextArea,
  Ts as Input,
  jt as Loader,
  Ns as MediaUpload,
  Ps as Message,
  Li as MobileBottomNavbar,
  Os as MobileBottomNavbarItem,
  Ri as MobileBottomNavbarPage,
  xs as MobileTopNavbar,
  $s as MobileTopNavbarItem,
  Is as Modal,
  Bs as ModalButtons,
  Ui as NavBar,
  Wi as NavBarHeading,
  Hi as NavBarList,
  Ds as NavBarListItem,
  xi as NotificationsProvider,
  Gi as PageHeader,
  zi as PageLoader,
  Fs as Pagination,
  Cs as PaymentIcon,
  ks as ProgressBar,
  Ms as Seatmap,
  Ls as Section,
  qi as SectionHeader,
  Ki as SidebarBottom,
  Rs as SidebarButton,
  ji as SidebarButtonLogo,
  Us as SidebarUserMenu,
  Vi as SortableTableBody,
  Ji as SortableTableBodyInner,
  Qi as SortableTableRow,
  Zi as SortableTableRowDrag,
  Xi as Spacer,
  Gr as Table,
  Qt as TableBody,
  Ae as TableCell,
  Yi as TableCellTitle,
  es as TableHead,
  Ws as TableHeadCell,
  Vt as TableRow,
  yt as Text,
  Hs as ThemeContext,
  Gs as ThemeProvider,
  zs as Tile,
  Or as Toggle,
  qs as Tooltip,
  Ks as Topbar,
  rs as UIAppContent,
  ts as UIAppLayout,
  js as UIAppSidebar,
  os as UIContentMain,
  ns as UIContentNavbar,
  as as UIContentTopbar,
  Vs as UIPage,
  qt as useAuth,
  $i as useEvent,
  Ii as useNotifications,
  Js as useOutsideClick,
  Nr as useTheme
};
